// export const decentrogeAddress = "0x9033A8F26B0Bc5DeF4381908fdf28DA99f36cCa1";
// export const decentrogeAddress = "0x37C14263Fd2fe77CA2A42FFA6D760Dd3d3AF04a8";
export const decentrogeAddress = "0x27BbbbB31663Ac002b232ae6fA0460fD42b57566";
